import { Moment } from "moment";

export enum DateFormatWithDashEnum {
  'Day_Month_Year' = 'DD-MM-YYYY',
  'Year_Month_Day' = 'YYYY-MM-DD',
}

export const formatDateWithDash = (date: Moment, type: DateFormatWithDashEnum):string => {
  let day = date.date().toString().padStart(2, '0');
  let month = (date.month() + 1).toString().padStart(2, '0');
  let year = date.year().toString();

  if(type === DateFormatWithDashEnum.Day_Month_Year){
    return `${day}-${month}-${year}`
  } else if (type === DateFormatWithDashEnum.Year_Month_Day){
    return `${year}-${month}-${day}`
  }

  return 'Proporcione un formato de fecha';
}

